import { useModal } from '@flyer/components';
import { ForgotPasswordFlowModalLazy } from '../index';

export default function useForgotPasswordModal() {
  const { toggleModal: openForgotPassword, hideModal: closeForgotPassword } = useModal(ForgotPasswordFlowModalLazy);

  return {
    openForgotPassword,
    closeForgotPassword,
  };
}
